import Loading from '../../Common/Loading';
import { usePacientProfileChartsDataContext } from './hooks/usePacientProfileChartsDataContext';
import { PatientBySex } from './PatientBySex';
import { PatientAgePyramid } from './PatientAgePyramid';
import { PatientSexByYear } from './PatientSexByYear';
import { PatientAvgPermanenceByAge } from './PatientAvgPermanenceByAge';

export const Charts = () => {
    const { isLoading } = usePacientProfileChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <PatientBySex />
                <PatientAgePyramid />
            </div>
            <div className="charts-side-by-side-dashboards">
                <PatientSexByYear />
                <PatientAvgPermanenceByAge />
            </div>
        </>
    );
};
